module.exports = "/_next/static/images/aboutUsImage-a4b7bc6a2ad83f689a5d8bed15c08ef6.webp";